import { IIconProps } from '../../types/IconProps.interface'

export const IconFacebook = ({ color = 'white', className }: IIconProps) => {
  return (
    <svg
      className={`w-full ${className}`}
      fill='none'
      viewBox='0 0 18 18'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.90909 7.78857e-07C13.8091 1.20723e-06 17.8182 4.02926 17.8182 8.95391C17.8182 13.386 14.6111 17.057 10.3794 17.8182L10.3381 17.7854C10.3662 17.7806 10.3949 17.7796 10.4229 17.7745L10.4229 11.4613L12.3827 11.4613L12.7851 8.95391L10.4229 8.95391L10.4229 7.20728C10.4231 6.49134 10.6919 5.9547 11.7606 5.9547L12.9177 5.9547L12.9177 3.67031C12.2942 3.5808 11.5815 3.49325 10.958 3.49325C8.90899 3.49331 7.48442 4.74588 7.48442 6.98431L7.48442 8.9539L5.25715 8.9539L5.25715 11.4613L7.48442 11.4613L7.48442 17.7745L7.48877 17.7745L7.43874 17.8182C3.2071 17.057 -1.17024e-06 13.386 -7.82775e-07 8.9539C-2.79836e-07 4.02926 4.00909 4.23264e-07 8.90909 7.78857e-07Z'
        fill={color}
      />
    </svg>
  )
}
